var _dec, _class;
import { mixins, Options } from 'vue-class-component';
import { WebMenuViewModel } from './WebMenuViewModel';
let WebMenu = (_dec = Options({
  props: {
    menuList: Array
  },
  watch: {
    $route: 'routerChangeEvent'
  }
}), _dec(_class = class WebMenu extends mixins(WebMenuViewModel) {}) || _class);
export { WebMenu as default };